export const TRYON_START = 'tryon.start';
export const TRYON_DONE = 'tryon.done';
export const TRYON_ERROR= 'tryon.error';

export const RESET_START = 'reset.start';
export const RESET_DONE = 'reset.done';

export const ADJUST_START = 'adjust.start';
export const ADJUST_DONE = 'adjust.done';